import { Component, OnInit, inject } from '@angular/core';
import { PostTradeService } from '../../post-trade.service';
import { CaseManagementService } from '../../../case-management/case-management.service';
import { TradeGridSummaryResponse } from '../../../models/post-trade-models';

import { AgingCasesTableComponent } from '../../components/aging-cases-table/aging-cases-table.component';
import { OpenRecordsTableComponent } from '../../components/open-records-table/open-records-table.component';

@Component({
  selector: 'app-rep-review-dashboard',
  templateUrl: './rep-review-dashboard.component.html',
  styleUrls: ['./rep-review-dashboard.component.scss'],
  imports: [AgingCasesTableComponent, OpenRecordsTableComponent],
})
export class RepReviewDashboardComponent implements OnInit {
  private ptSvc = inject(PostTradeService);
  cms = inject(CaseManagementService);

  agingCases = [];
  openRecords = {};

  ngOnInit(): void {
    this.ptSvc.loading.set(true);
    this.cms
      .getCaseManagementData({
        search: {
          profileValues: {
            StatusName: 'Assigned',
            Type: ['Rep', 'RepGroup'],
          },
        },
        take: 10,
        sort: {
          DateLastUpdated: 'asc',
        },
      })
      .subscribe({
        next: resp => {
          if (resp['data']) {
            this.agingCases = resp['data'];
          }

          if (this.ptSvc.loading()) {
            this.ptSvc.loading.set(false);
          }
        },
        error: err => {
          console.warn('Error: ', err);
        },
      });

    this.ptSvc.getRepGridSummary().subscribe({
      next: (resp: TradeGridSummaryResponse) => {
        if (resp.data) {
          this.openRecords = resp.data[0];
        }

        if (this.ptSvc.loading()) {
          this.ptSvc.loading.set(false);
        }
      },
      error: err => {
        console.warn('Error: ', err);
      },
    });
  }
}
